import axios from "axios";

// Speech proposes only these two fields. Identity and revision always come
// from the authenticated screen, never from model-supplied arguments.
export function briefingPlanProposal(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)
      || Object.keys(value).some(key => !["goal", "support_percent"].includes(key))
      || !(value.goal === null || (typeof value.goal === "string" && value.goal.trim().length > 0 && value.goal.trim().length <= 240))
      || !(value.support_percent === null || (Number.isInteger(value.support_percent) && value.support_percent >= 0 && value.support_percent <= 100))) {
    throw new Error("Please agree a clear goal and amount of support first.");
  }
  return { goal: value.goal?.trim() ?? null, support_percent: value.support_percent };
}

export async function saveBriefingPlan(change, signal) {
  const { lessonId, pupilId, expectedRevision, expectedPlan, goal, support_percent } = change;
  const target = { ...expectedPlan, desired_focus: goal || expectedPlan.desired_focus };
  if (support_percent !== null) target.desired_support_percent = support_percent;
  const confirmed = lesson => lesson?.id === lessonId && lesson?.student_id === pupilId
    && lesson.goal_revision === expectedRevision + 1
    && Object.keys(target).length === Object.keys(lesson.run_my_day_plan || {}).length
    && Object.entries(target).every(([key, value]) => JSON.stringify(lesson.run_my_day_plan[key]) === JSON.stringify(value));
  const config = { withCredentials: true, timeout: 20000, signal };
  try {
    const { data } = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/work-mode/lessons/${lessonId}/goal`, {
      goal: target.desired_focus, support_percent, expected_revision: expectedRevision, expected_plan: expectedPlan,
    }, config);
    if (signal.aborted) throw new Error("Briefing cancelled");
    if (!confirmed(data.lesson)) throw new Error("The saved briefing choices could not be confirmed.");
    return data.lesson;
  } catch (failure) {
    if (signal.aborted) throw failure;
    // A lost reply or repeated local draft may already have saved. Only the
    // exact next revision and complete matching plan count as recovery.
    if (failure?.response?.status === 409 || ["ECONNABORTED", "ETIMEDOUT"].includes(failure?.code)) {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-mode/lessons/active`, config);
      if (!signal.aborted && confirmed(data.lesson)) return data.lesson;
    }
    throw new Error("Your agreed briefing choices have not been confirmed saved. Retry, or keep the saved plan.");
  }
}

export async function readSavedBriefingPlan(change, signal) {
  const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-mode/lessons/active`, { withCredentials: true, timeout: 20000, signal });
  if (signal.aborted || data.lesson?.id !== change.lessonId || data.lesson?.student_id !== change.pupilId) {
    throw new Error("The current saved plan could not be confirmed. Please retry.");
  }
  return data.lesson;
}
